import { render, staticRenderFns } from "./EmployeeGoalKpiEditor.vue?vue&type=template&id=2748b3ec&scoped=true&"
import script from "./EmployeeGoalKpiEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeeGoalKpiEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748b3ec",
  null
  
)

export default component.exports